import { Action } from '@ngrx/store';
import { Comment } from '../../declarations/comment.interface';

export const SET_EDITING_COMMENT = 'COMMENT:SET_EDITING_COMMENT';

export class SetEditingComment implements Action {
  readonly type = SET_EDITING_COMMENT;
  constructor(public payload: Comment | null) {}
}
